import cn from "classnames"
import { HTMLAttributes, ReactNode } from "react"

interface CheckboxProps extends HTMLAttributes<HTMLInputElement> {
    checked?: boolean
    isDisabled?: boolean
    isDanger?: boolean
    children?: ReactNode
    labelClassName?: string
    className?: string
    value?: number | string
}

export function Checkbox({
    className,
    isDisabled,
    children,
    isDanger,
    labelClassName,
    checked,
    ...props
}: CheckboxProps) {
    return (
        <label
            className={cn("b-checkbox blm-checkbox is-align-items-baseline checkbox", className, {
                "is-disabled": isDisabled,
                "is-danger": isDanger,
                "is-active": checked,
            })}
        >
            <input type="checkbox" disabled={isDisabled} checked={checked} {...props} />
            <span className="check" />
            {children && <span className={cn("control-label", labelClassName)}>{children}</span>}
        </label>
    )
}
